import { useNavigate, useParams } from "react-router";
import t from "@/lang/lang";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import {
  CustomerPageMain,
  CustomerPageMainContent,
  CustomerPageMainHeader,
} from "@/routes/customers/[customerId]/_components/customer-page";
import { CustomerPageBreadcrumbs } from "@/routes/customers/[customerId]/_components/customer-page-breadcrumbs";
import {
  useBuildingsDeleteMutation,
  useBuildingsShowQuery,
} from "@/services/backend/buildings/api/building-api";
import { parseRTKQueryErrorToSonner } from "@/shared/components/errors/parse-r-t-k-query-error";
import { BuildingDetailsPage } from "@/services/backend/buildings/components/building-details-page";
import { UUID } from "@bitory-gmbh/nidavellir";
import { toast } from "sonner";

export function BuildingRoute() {
  const { customerId, buildingId } = useParams();
  const navigate = useNavigate();
  const { data, error, isLoading } = useBuildingsShowQuery(
    { id: buildingId! },
    { skip: !buildingId },
  );
  const [deleteBuilding, deleteState] = useBuildingsDeleteMutation();

  const doDelete = (id: UUID) => {
    if (deleteState.isLoading) return;

    deleteBuilding({ id })
      .unwrap()
      .then(() => {
        navigate(`/customers/${customerId}/buildings`);
      })
      .catch((err) => {
        toast(...parseRTKQueryErrorToSonner(err));
        deleteState.reset();
      });
  };

  return (
    <CustomerPageMain>
      <CustomerPageMainHeader>
        <CustomerPageBreadcrumbs
          breadcrumbs={[
            {
              to: `/customers/${customerId}/buildings`,
              label: t("Gebäudeverwaltung"),
            },
            {
              to: `/customers/${customerId}/buildings/${buildingId}`,
              label: data?.name ?? t("Gebäude"),
            },
          ]}
        />
      </CustomerPageMainHeader>
      <CustomerPageMainContent className="gap-4">
        {error && <RTKQueryErrorAlert error={error} />}
        {isLoading && <div>{t("Lade Gebäude...")}</div>}
        {data && (
          <BuildingDetailsPage
            customerId={customerId!}
            building={data}
            onDeleteBuilding={doDelete}
          />
        )}
      </CustomerPageMainContent>
    </CustomerPageMain>
  );
}
